module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "explainDetailed"
    }
  }, [_c('h1', [_vm._v("补交阶梯差价计算说明")]), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('el-table', {
    ref: "filterTable",
    staticStyle: {
      "width": "1200px",
      "margin": "auto"
    },
    attrs: {
      "data": _vm.tableData
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "grade",
      "label": "年阶梯分档"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "range",
      "label": "电量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "电价（元 / 度）"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": scope.row.type === 0 ? 'success' : scope.row.type === 1 ? 'warning' : 'danger',
            "disable-transitions": ""
          }
        }, [_vm._v("￥ " + _vm._s(scope.row.price))])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('el-alert', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "title": "",
      "type": "info",
      "description": "电表设置电价说明：本年阶梯电表设置电价为无阶梯0.52元/度，电表本身计量一直按照0.52元/度计算，如果用量超出阶梯范围，则进行补交差价，补交差价在充值时自动扣除。",
      "show-icon": "",
      "closable": false
    }
  }), _vm._v(" "), _c('el-collapse', {
    model: {
      value: (_vm.activeNames),
      callback: function($$v) {
        _vm.activeNames = $$v
      },
      expression: "activeNames"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": "本次补交阶梯差价计算明细：",
      "name": "1"
    }
  }, [_c('p', [_vm._v("充值前本年用量："), _c('span', {
    staticClass: "val"
  }, [_vm._v(_vm._s(_vm.diffLoad.yeartotal))]), _vm._v(" 度")]), _vm._v(" "), _c('p', [_vm._v("超过标准用量："), _c('span', {
    staticClass: "val"
  }, [_vm._v(_vm._s(_vm.diffLoad.exceed))]), _vm._v(" 度 "), (_vm.newyear != 0) ? _c('small', {
    staticClass: "red"
  }, [_vm._v("（注：上次缴费日期截止到当前超出的标准用量）")]) : _vm._e()]), _vm._v(" "), _c('p', [_vm._v("第二阶梯差价单价：0.05 元 / 度")]), _vm._v(" "), _c('p', [_vm._v("第三阶梯差价单价：0.3 元 / 度")]), _vm._v(" "), _c('p', [_vm._v("第二阶梯差价：" + _vm._s(_vm.diffLoad.first) + " 度 * 0.05 = " + _vm._s(_vm.diffLoad.firstDiff) + " 元")]), _vm._v(" "), _c('p', [_vm._v("第三阶梯差价：" + _vm._s(_vm.diffLoad.two) + " 度 * 0.3元 = " + _vm._s(_vm.diffLoad.twoDiff) + " 元")]), _vm._v(" "), _c('p', [_vm._v("补交阶梯差价：第一阶梯差价 + 第二阶梯差价 = " + _vm._s(_vm.diffLoad.diff) + " 元")])])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.store/vue-loader@11.3.4/~/vue-loader/lib/template-compiler?{"id":"data-v-4098cd6a"}!./~/.store/vue-loader@11.3.4/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/explainDetailed.vue
// module id = 527
// module chunks = 1